import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7d2213eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "path" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "path-btn-text"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "path-btn-text"
}
const _hoisted_9 = {
  key: 1,
  class: "path-btn-text"
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 0,
  class: "path-btn-text"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "path-btn-text"
}
const _hoisted_14 = {
  key: 1,
  class: "path-btn-text"
}
const _hoisted_15 = { class: "current-section" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

import { computed, PropType } from "vue";
import { useUIContentStore } from "@/stores/ui-content.store";
import { ProductItem } from "@/models/product.model";
import { AssetLocation } from "@/models/assets.model";
import {
  getInternalPath,
  getShortProductName
} from "@/utils/content-path-helpers";
import SectionIcon from "@/components/SectionIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentLocationPath',
  props: {
  product: {
    required: true,
    type: Object as PropType<ProductItem>
  },
  path: {
    required: true,
    type: Array as PropType<AssetLocation[]>
  },
  sectionName: {
    required: true,
    type: String
  },
  sectionId: {
    required: true,
    type: Number
  },
  sectionIconId: {
    required: true,
    type: Number
  },
  sectionExternalId: {
    required: true,
    type: String
  },
  showAsExternal: {
    default: false,
    type: Boolean,
    required: false
  },
  isClickable: {
    default: true,
    type: Boolean,
    required: false
  },
  isLongPathNameEnabled: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const uiContentStore = useUIContentStore();

const props = __props;

const productShortName = computed<string>(() => {
  return getShortProductName(props.product.name);
});
const internalPath = computed<string>(() => {
  return getInternalPath(props.path, props.product.name, props.sectionName);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", { title: internalPath.value }, [
      (__props.isClickable)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/product/${__props.product.id}`,
            class: "btn-unstyled"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.product.name), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.product.name), 1)),
      _createTextVNode("  / "),
      (__props.path.length && __props.isClickable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.path, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                key: item.id,
                class: "btn-unstyled",
                onClick: ($event: any) => (
            _unref(uiContentStore).openContentSidebar({
              sectionId: item.id,
              productId: __props.product.id,
              workflowStateId: 0,
              hasCloseButton: true
            })
          )
              }, [
                _createVNode(SectionIcon, {
                  class: "mr-1",
                  "icon-id": item.iconId,
                  size: 16
                }, null, 8, ["icon-id"]),
                (__props.showAsExternal)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.externalId), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      (__props.isLongPathNameEnabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.name), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(productShortName.value) + "-" + _toDisplayString(item.id), 1))
                    ])),
                _createTextVNode(" /  ")
              ], 8, _hoisted_5))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.path.length && !__props.isClickable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.path, (item) => {
              return (_openBlock(), _createElementBlock("span", {
                key: item.id
              }, [
                _createVNode(SectionIcon, {
                  class: "mr-1",
                  "icon-id": item.iconId,
                  size: 16
                }, null, 8, ["icon-id"]),
                (__props.showAsExternal)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.externalId), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      (__props.isLongPathNameEnabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.name), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(productShortName.value) + "-" + _toDisplayString(item.id), 1))
                    ])),
                _createTextVNode(" /  ")
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_15, [
        _createVNode(SectionIcon, {
          class: "mr-1",
          "icon-id": __props.sectionIconId,
          size: 16
        }, null, 8, ["icon-id"]),
        (__props.showAsExternal)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(__props.sectionExternalId), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_17, [
              (__props.isLongPathNameEnabled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(__props.sectionName.trim()), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(productShortName.value) + "-" + _toDisplayString(__props.sectionId), 1))
            ]))
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})